import { Modal } from "react-bootstrap";
import { useState } from "react";
import { Datasets } from "../../components/Dataset/Dataset";
import "../../styles/DatasetPage.css";
import "../../styles/org-buttons.css";
import NavigationBar from "../../components/NavBar/NavBar";
import DatasetWorkspaceShell from "../../components/Dataset/DatasetWorkspaceShell";
import DownSamplingPage from "./pages/DownSamplingPage";
import DeleteRedundantPage from "./pages/DeleteRedundantPage";
import DeleteSamplesPage from "./pages/DeleteSamplesPage";
import StableDiffusionPage from "./pages/StableDiffusionPage";
import AnomalySynthesisPage from "./pages/AnomalySynthesisPage";
import TextToImagePage from "./pages/TextToImagePage";
import { buttonText } from "../../utils/buttonText";
import { pageText } from "../../utils/pageText";
function DataProcessingPage() {
  return (
    <div>
      <NavigationBar />
      <DatasetWorkspaceShell>
        <Datasets
          CustomizedContent={CustomizedContent}
          overviewTitle="Data Processing"
          overviewDescription="Clean, sample, remove redundant data, and generate synthetic samples from selected datasets."
        />
      </DatasetWorkspaceShell>
    </div>
  );
}

const nameToTitleName = {
  dataCleansing: "Data Cleansing",
  dataCreating: "Data Generation",
  downsampling: "Sampling",
  deleteRedundant: "Delete Redundant Samples",
  deleteSamples: "Delete Selected Samples",
  stableDiffusion: "Stable Diffusion",
  anomalySynthesis: "Anomaly Synthesis",
  textToImage: "API Image Generation",
};

function CustomizedContent(props) {
  const { item } = props;

  const [pageName, setPageName] = useState(null);
  const sampleCount = item.samples?.length || 0;

  const showModel = pageName && nameToTitleName.hasOwnProperty(pageName);

  const isCommon = item.folder !== "Yes" && item.table !== "Yes";
  if (!isCommon) {
    return (
      <div className="folder-table-dataset-tips">
        <p>{pageText("You can process data in dataset that represents a folder/table")}</p>
        {item.folder === "Yes" && (
          <div>
            <p>{pageText("If you want to process data in a folder dataset,")}</p>
            <p>
              {pageText("please click 'Folders' tab, but this feat is not implemented yet.")}
            </p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="dataset-customized-content">
      <div className="dataset-info">
        <div className="dataset-info-grid">
          <div className="dataset-info-item">
            <span>{pageText("Type")}</span>
            <strong>{pageText(item.media_type || "unknown")}</strong>
          </div>
          <div className="dataset-info-item">
            <span>{pageText("Samples")}</span>
            <strong>{sampleCount.toLocaleString()}</strong>
          </div>
          <div className="dataset-info-item">
            <span>{pageText("Size")}</span>
            <strong>{item.size || "N/A"}</strong>
          </div>
        </div>
      </div>
      
      <div className="data-processing-button-group">
        <button
          type="button"
          className="org-btn org-btn-secondary"
          onClick={() => setPageName("dataCleansing")}
        >
          {buttonText("Data Cleansing")}
        </button>
        <button
          type="button"
          className="org-btn org-btn-secondary"
          onClick={() => setPageName("dataCreating")}
        >
          {buttonText("Data Generation")}
        </button>
      </div>
      
      <DataProcessingPageModal
        show={showModel}
        onHide={() => setPageName(null)}
        pageName={pageName}
        setPageName={setPageName}
        {...props}
      />
    </div>
  );
}

function DataCleansingContent(props) {
  const { setPageName } = props;

  return (
    <div className="data-processing-button-group">
      <button
        type="button"
        className="org-btn org-btn-secondary"
        onClick={() => setPageName("downsampling")}
      >
        {buttonText("Sampling")}
      </button>
      <button
        type="button"
        className="org-btn org-btn-secondary"
        onClick={() => setPageName("deleteRedundant")}
      >
        {buttonText("Delete Redundant")}
      </button>
      <button
        type="button"
        className="org-btn org-btn-secondary"
        onClick={() => setPageName("deleteSamples")}
      >
        {buttonText("Delete Samples")}
      </button>
    </div>
  );
}

function DataCreatingPage(props) {
  const { setPageName } = props;

  return (
    <div className="data-creating-page">
      <div className="data-processing-button-group">
        <button
          type="button"
          className="org-btn org-btn-secondary"
          onClick={() => setPageName("stableDiffusion")}
        >
          {buttonText("Stable Diffusion 1.5")}
        </button>
        <button
          type="button"
          className="org-btn org-btn-secondary"
          onClick={() => setPageName("anomalySynthesis")}
        >
          {buttonText("Anomaly Synthesis")}
        </button>
        <button
          type="button"
          className="org-btn org-btn-secondary"
          onClick={() => setPageName("textToImage")}
        >
          {buttonText("API Image Generation")}
        </button>
      </div>
    </div>
  );
}

function DataProcessingPageModal(props) {
  const { pageName } = props;

  const nameToComponent = {
    dataCleansing: <DataCleansingContent {...props} />,
    dataCreating: <DataCreatingPage {...props} />,
    downsampling: <DownSamplingPage {...props} />,
    deleteRedundant: <DeleteRedundantPage {...props} />,
    deleteSamples: <DeleteSamplesPage {...props} />,
    stableDiffusion: <StableDiffusionPage {...props} />,
    anomalySynthesis: <AnomalySynthesisPage {...props} />,
    textToImage: <TextToImagePage {...props} />,
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      isOpen={props.show}
      onHide={props.onHide}
      className="dataset-enterprise-modal"
    >
      <Modal.Header closeButton closeLabel={buttonText("Close")} className="dataset-modal-header">
        <Modal.Title id="contained-modal-title-vcenter">
          {nameToTitleName[pageName]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="dataset-modal-body">{nameToComponent[pageName]}</Modal.Body>
    </Modal>
  );
}

export default DataProcessingPage;
